// import { SideNavBarButtons } from ".."
import { LogoutButton } from "./logoutButton"
import { SideNavBarButtons } from "./sideNavBarButtons"
import styles from "./style.module.css"

export const SideNavBar = () => {

    return(

        <div className={styles.container}>

        {/* sideNav */}

        {/* <SideNavBarButtons/> */}

        <SideNavBarButtons/>

        <LogoutButton/>

        </div>

    )
}